import React, { useState } from "react";
import { ReactComponent as LogoutIcon } from "../assets/images/icons/logout.svg";
import { useAuth0 } from "@auth0/auth0-react";
import { CsrAPI } from "../apis/CsrAPI";
import Loader from "../utils/Loader";

const ProfilePopup = () => {
  const { user, logout } = useAuth0();
  const [loggingOut, setLoggingOut] = useState(false);

  const handleLogout = async () => {
    setLoggingOut(true);
    await CsrAPI.logout();
    localStorage.clear();
    setLoggingOut(false);
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  if (loggingOut) {
    return <Loader></Loader>;
  }

  return (
    <div className="profile-popup profile-popup__wrapper">
      <div className={"profile-popup__name"}>
        <span className={"profile-popup__name-label"}>Logged in as:</span>
        <span>{user.name}</span>
      </div>
      <button
        className={"input-submit input-submit__primary"}
        onClick={handleLogout}>
        <LogoutIcon />
        Logout
      </button>
    </div>
  );
};

export default ProfilePopup;
